module.exports = __webpack_public_path__ + "img/hand-point-down.7226eaf8.svg";